// Aggregate outcomes only: no student names, IDs, filenames or error messages.
export const IMPORT_ACTIVITY = {
  seis: 'lastSeisImport',
  'aeries-schedule': 'lastScheduleImport',
  'aeries-contacts': 'lastAeriesContactsImport',
  'aeries-504': 'lastAeries504Import'
}

const count = (value) => Math.max(0, Number(value) || 0)

export function buildImportOutcome(source, result = {}, finishedAt = new Date().toISOString()) {
  const issues =
    (result.errors || result.failures || []).length +
    (result.details?.evaluations?.failures || []).length
  return {
    finishedAt,
    status: issues ? 'issues' : 'success',
    updated: count(source === 'seis' ? result.details?.updatedCount : result.updated),
    created: count(source === 'seis' ? result.details?.createdCount : result.created),
    issues
  }
}

export function importActivityPatch(source, outcome, by) {
  const prefix = IMPORT_ACTIVITY[source]
  if (!prefix) throw new Error('Unknown import source')
  // Restoration is new activity, not a new import. Keep the original import
  // timestamp/operator for other status panels that consume these legacy keys.
  if (outcome.status === 'restored' || outcome.status === 'restore-issues') {
    return { [`${prefix}Result`]: outcome }
  }
  return {
    [`${prefix}At`]: outcome.finishedAt,
    [`${prefix}By`]: by || 'unknown',
    [`${prefix}Result`]: outcome
  }
}

export function importOutcomeToken(settings, source, { unsaved = false } = {}) {
  if (!IMPORT_ACTIVITY[source]) return 'missing'
  if (unsaved) return 'unsaved'
  const prefix = IMPORT_ACTIVITY[source]
  const result = settings?.[`${prefix}Result`]
  const at = result?.finishedAt || settings?.[`${prefix}At`] || null
  if (!result) return at ? 'unrecorded' : 'missing'
  if (result.status === 'restored') return 'restored'
  if (result.status === 'restore-issues') return 'restore-issues'
  if (result.status === 'issues' || count(result.issues) > 0) return 'issues'
  if (result.status === 'success') return 'success'
  return 'unrecorded'
}

export function describeImportActivity(settings, source) {
  const prefix = IMPORT_ACTIVITY[source]
  const result = settings?.[`${prefix}Result`]
  const at = result?.finishedAt || settings?.[`${prefix}At`] || null
  if (!result)
    return {
      label: at ? 'Imported — outcome not recorded' : 'No import recorded',
      tone: 'wait',
      at,
      detail: ''
    }
  const restored = result.status === 'restored' || result.status === 'restore-issues'
  const issues = count(result.issues)
  const label = restored
    ? issues
      ? 'Restore needs attention'
      : 'Previous values restored'
    : issues
      ? 'Imported with issues'
      : 'Imported successfully'
  return {
    label,
    tone: issues ? 'issues' : 'done',
    at,
    detail: restored
      ? `${count(result.restored)} restored · ${issues} issues`
      : `${count(result.updated)} updated · ${count(result.created)} created · ${issues} issues`
  }
}
